// extracted by mini-css-extract-plugin
export var back = "go-back-module--back--3M0OH";